import React from 'react';
import get from 'lodash/get';
import styled from 'styled-components';
import { SPACES } from 'common/constants/sizes';
import Text, { Inline } from 'components/base/Text';
import { Padding, TooltipStyled } from 'components/base/layout-components';

const TooltipContentWrapper = styled.div`
  padding: 0.5rem 0;
`;

export const CustomPieTooltip = ({ active, payload }) => {
  if (active) {
    return (
      payload && (
        <TooltipStyled padding='0.5rem'>
          <Text size='small' weight='500' pb={SPACES['x-small']}>
            {get(payload[0], `name`, '-')}
          </Text>
          <div>
            <Inline pr='0.5rem' size='small'>
              {get(payload[0], `payload.total`, '-')}
            </Inline>
            <Inline size='small' color='shuttleGray'>{`(${get(
              payload[0],
              `value`,
              '0'
            )}%)`}</Inline>
          </div>
        </TooltipStyled>
      )
    );
  }

  return null;
};

export const CustomLineTooltip = ({
  active,
  payload,
  convertMinutesToTotalDisplay
}) => {
  if (active) {
    return (
      payload && (
        <TooltipStyled padding='1rem'>
          <Text size='medium' weight='500' pb={SPACES['x-small']}>
            {get(payload, `[0]payload.iterationName`, '-')}
          </Text>
          <Text size='small' color='shuttleGray' pb={SPACES['small']}>
            {get(payload, `[0]payload.iterationDates`, '-')}
          </Text>
          {payload.map(({ name, color, payload }, idx) => {
            const percent = get(
              payload,
              `stats.issue_type_stats_by_type[${name}].percents`,
              '-'
            );
            const total = convertMinutesToTotalDisplay(
              get(
                payload,
                `stats.issue_type_stats_by_type[${name}].totalInUnits`,
                null
              )
            );

            return (
              <Padding b='small' key={idx}>
                <div
                  style={{
                    display: 'inline-block',
                    marginRight: '0.5rem',
                    width: '0.8rem',
                    height: '0.8rem',
                    backgroundColor: color
                  }}
                ></div>
                <Inline size='medium' pr='0.5rem'>
                  {name}
                </Inline>
                <Inline pr='0.5rem' size='small'>
                  {total}
                </Inline>
                <Inline size='small' color='shuttleGray'>
                  ({percent.toFixed(2)}%)
                </Inline>
              </Padding>
            );
          })}
        </TooltipStyled>
      )
    );
  }

  return null;
};

export const MoreIssueTypesTooltip = ({ tableConfig }) => {
  return (
    <TooltipContentWrapper>
      <Text size='medium' weight='500' pl='5px' pb='5px'>
        more issue types:
      </Text>
      <table cellpadding='5'>
        {tableConfig
          .filter(({ isMoreIssueType }) => isMoreIssueType)
          .map(({ key, convertedTotalDays, percents }) => {
            return (
              <tr key={key}>
                <td>
                  <Inline
                    size='medium'
                    whiteSpace='nowrap'
                    weight='500'
                    pr='0.3rem'
                  >
                    {convertedTotalDays}
                  </Inline>
                  <Inline size='medium' whiteSpace='nowrap' color='shuttleGray'>
                    ({Math.round(percents, 1)}%)
                  </Inline>
                </td>
                <td>
                  <Text size='medium' color='shuttleGray' whiteSpace='nowrap'>
                    {key}
                  </Text>
                </td>
              </tr>
            );
          })}
      </table>
    </TooltipContentWrapper>
  );
};
